import React, { useEffect, useRef, useState } from "react";
import Title from "../../component/PageTitle";
import { Button, Tooltip, Space, Input, Table, Modal, Switch, Collapse, Spin, Pagination, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {
    useGetPropertyProvidersQuery,
    useGetIncomeQuery,
    useLazyGetStatisticsQuery,
    useGetExpenseByPropertyQuery
} from "../../slices/getSlice";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { useDeleteExpenseByCompanyPropertyMutation } from "../../slices/apiSlice";
import { FaEdit } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";
import { HiOutlineTrash } from "react-icons/hi2";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import TopHeader from "../../component/Header";
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import swal from "sweetalert";
import { InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useDeleteIncomeMutation, useUpdateRecurringMutation } from "../../slices/apiSlice";

const ViewProperty = () => {
    const start_Date = useSelector((state) => state.date.startDate);
    const end_Date = useSelector((state) => state.date.endDate);
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const { loading, setLoading } = useOutletContext();
    let propertyDataState = location?.state?.propertyData;
    const propertyId =
        Number.isInteger(propertyDataState?.property_id)
            ? propertyDataState.property_id
            : propertyDataState?.propertyId ? propertyDataState?.propertyId : propertyDataState.id;
    const propertyName = propertyDataState?.providerType ? propertyDataState?.providerType : location?.state?.propertyData?.name_of_property;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteIncomeModal, setIsDeleteIncomeModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState("");
    const [selectedIncomeRecord, setSelectedIncomeRecord] = useState("");
    const [deleteExpense, { isLoading: isLoadingDelete }] = useDeleteExpenseByCompanyPropertyMutation();
    const [isRefetching, setIsRefetching] = useState(false);
    const currencyGlobal = useSelector((state) => state?.persistedReducer?.currency)
    const currency = currencyGlobal ? currencyGlobal : '';
    const [isClicked, setIsClicked] = useState(propertyDataState?.providerType && propertyDataState?.provider_type_id ? true : false);
    const [tableLoading, setTableLoading] = useState(false);
    const startDate = useSelector((state) => state.date.startDate);
    const endDate = useSelector((state) => state.date.endDate);
    const [currentPage, setCurrentPage] = useState(1);
    const [tableSortBy, setTableSortBy] = useState(null);
    const [columnName, setColumnName] = useState(null);
    const [localLoading, setLocalLoading] = useState(false);
    const [totalIncome, setTotalIncome] = useState(null);
    const [updateRecurring, { isLoading: loadingRecurring }] = useUpdateRecurringMutation();
    const [pagesize, setPageSize] = useState(20);
    const [statistics, setStatistics] = useState(null);
    const [loader, setLoader] = useState(true);
    const [expenseData, setExpenseData] = useState([]);
    const [totalExpense, SetTotalExpense] = useState(null);
    const [deleteIncome, { }] = useDeleteIncomeMutation();
    const [fetchStatistics, { isLoading: isStatisticsLoading, isError: isStatisticsError }] = useLazyGetStatisticsQuery();

    const queryParams = [
        `page=${currentPage}`,
        `per_page=${pagesize}`,
        searchText ? `search=${searchText}` : "",
        tableSortBy && columnName ? `sort_direction=${tableSortBy}&sort_by=${columnName}` : "",
        startDate ? `start_date=${startDate}` : "",
        endDate ? `end_date=${endDate}` : "",
        `property_ids=${propertyId}`
    ]
        .filter(Boolean)
        .join("&");

    const {
        data: getIncome,
        isLoading,
        isError,
        refetch,
        error
    } = useGetIncomeQuery(`?${queryParams}`);

    const propertyData = location?.state?.propertyData;

    const { data: expenses, isLoading: isLoadingExpense, isError: isErrorExpense, refetch: refetchExpense } = useGetExpenseByPropertyQuery(propertyData?.property_id ? propertyData?.property_id : propertyData?.id);

    useEffect(() => {
        refetchExpense();
    }, []);

    const data = React.useMemo(() => ({
        skip: isClicked,
        propertyId: propertyId || location?.state?.property_id,
        propertyName: propertyName,
        query: start_Date && end_Date ? `?start_date=${start_Date}&end_date=${end_Date}` : null,
    }), [isClicked, propertyId, location?.state?.provider_type_id, propertyName, start_Date, end_Date]);

    const {
        data: getPropertyProviders,
        isLoading: isPropertyProvidersLoading,
        refetch: refetchPropertyProvider,
        isError: isPropertyProviderError,
    } = useGetPropertyProvidersQuery(data);

    const dataSource = getIncome?.data ? getIncome.data.map((item) => ({
        property_id: item.property.name_of_property,
        propertyId: item.property.id,
        amount: item.amount,
        start_date: item.start_date,
        end_date: item.end_date,
        id: item.id,
        created_at: item.created_at,
        payment_type_id: item.payment_type_id,
        payment_type_name: item.payment_type_name,
        frequency: item?.frequency,
        notes: item?.notes,
        payment_mode_id: item?.payment_mode_id,
        propertyData: item?.property,
        parent_id: item?.parent_id,
        is_recurring_on: item?.is_recurring_on
    })) : [];

    const formatDate = (date) => {
        if (date) {
            return dayjs(date, "MM/DD/YYYY").format("YYYY-MM-DD");
        }
    };

    useEffect(() => {
        if (expenses && expenses?.data) {
            SetTotalExpense(expenses?.total_expense);
            const expenseArray = Object.values(expenses?.data);
            setExpenseData(expenseArray);
        }
    }, [expenses]);

    const fetchData = async () => {
        setLocalLoading(true);
        await refetch();
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        let statsData = await fetchStatistics({ start_date: formattedStartDate, end_date: formattedEndDate, property_ids: propertyId });
        setStatistics(statsData?.data);
        setLocalLoading(false);
    };

    useEffect(() => {
        setTableLoading(true);
        if (getIncome) {
            setLoading(false);
            setTableLoading(false);
            setTotalIncome(getIncome?.total_income);
        }
        fetchData().finally(() => setTableLoading(false));
    }, [getIncome, startDate, endDate]);

    useEffect(() => {
        return () => {
            setExpenseData([]);
        };
    }, []);

    const handleToggleChange = (checked, record) => {
        if (!record?.id) {
            toast.error("Invalid record. Please try again.");
            return;
        }

        swal({
            title: "Are you sure?",
            text: `If you turn this ${checked ? "on" : "off"}, recurring income will ${checked ? "automatically be added to this property again." : "no longer be added to this property"} .`,
            // icon: "warning",
            // buttons: ["Cancel", "Yes, confirm!"],
            dangerMode: true,
            buttons: {
                confirm: {
                    text: "Yes, confirm!",
                    value: true,
                    visible: true,
                    className: "custom-confirm-btn",
                    closeModal: true,
                },
                cancel: {
                    text: "Cancel",
                    value: null,
                    visible: true,
                    className: "custom-cancel-btn",
                    closeModal: true,
                },
            },
        }).then(async (willConfirm) => {
            if (willConfirm) {
                let formData = {
                    type: "income",
                    id: record?.id,
                    is_recurring_on: checked ? 1 : 0
                };

                try {
                    let changeStatus = await updateRecurring(formData);

                    if (changeStatus?.error) {
                        toast.error(changeStatus?.error?.message || "Failed to update status.");
                    } else {
                        toast.success(changeStatus?.data?.message || "Status updated successfully.");
                        refetch();
                    }
                } catch (error) {
                    toast.error("Something went wrong! Please try again.");
                    console.error("API Error:", error);
                }
            }
        });
    };

    const Columns = [
        {
            title: "S.No.",
            dataIndex: "serial",
            render: (_, record, index) =>
                (currentPage - 1) * pagesize + index + 1,
        },
        {
            title: "Property Name",
            dataIndex: "name_of_property",
            render: (_, record) => (
                <>
                    {record?.property_id}
                </>
            ),
            sorter: true,
        },
        {
            title: "Income",
            dataIndex: "amount",
            render: (amount) => {
                const currencySymbol = currency?.currency_symbol || "$";
                const currencyName = currency?.currency_name || "USD";

                return new Intl.NumberFormat(currencyName.includes("Rupee") ? "en-IN" : "en-US", {
                    style: "currency",
                    currency: currencyName.includes("Rupee") ? "INR" : "USD",
                }).format(amount || 0);
            },
            sorter: true,
        },
        {
            title: "Income Date",
            dataIndex: "start_date",
            sorter: true,
            render: (text) => (text ? dayjs(text).format("MM/DD/YYYY") : "N/A"),
        },
        {
            title: "Income Name",
            dataIndex: "notes",
            sorter: true,
            render: (notes) => (
                <Tooltip title={notes}>
                    <div className="income-name">
                        {notes ? notes : '-'}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: "Income Type",
            dataIndex: "payment_type_name",
            render: (_, record) => record?.payment_type_name,
            sorter: true,
        },
        {
            title: (
                <>
                    Status{" "}
                    <Tooltip title="Turn on/off recurring payment">
                        <InfoCircleOutlined className="infoIcon" />
                    </Tooltip>
                </>
            ),
            dataIndex: "status",
            render: (_, record) => (
                <div className="statusWrapper">
                    {record?.parent_id === null && record?.payment_type_name === "Recurring" && (
                        <>
                            <Switch
                                checked={record.is_recurring_on === true ? true : false}
                                onChange={(checked) => handleToggleChange(checked, record)}
                                className="toggleSwitch"
                            />
                        </>

                    )}
                </div>
            ),
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (_, record) => (
                <div className="action-container">
                    <Tooltip title="Edit">
                        <button
                            className="btn editButton me-2"
                            onClick={() =>
                                navigate(`/add_income?type=property`, {
                                    state: {
                                        id: record?.id,
                                        propertyData: propertyDataState
                                    },
                                })
                            }
                        >
                            <FaEdit />
                        </button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <button
                            className="btn deleteButton me-2"
                            onClick={() => {
                                setSelectedIncomeRecord(record.id);
                                setIsDeleteIncomeModal(true);
                            }}
                        >
                            <HiOutlineTrash />
                        </button>
                    </Tooltip>
                </div>
            ),
        },
    ];

    const handleOk = async (id) => {
        const res = await deleteExpense(selectedRecord);
        if (res?.data?.message) {
            refetchExpense();
            setIsModalOpen(false);
            toast.success(res?.data?.message)
        }
    };

    const handleOkIncome = async () => {
        const res = await deleteIncome(selectedIncomeRecord);
        if (res?.data?.message) {
            const totalPages = Math.ceil((dataSource.length - 1) / pagesize);
            if (currentPage > totalPages) {
                setCurrentPage(totalPages);
            }
            refetch();
            setIsDeleteIncomeModal(false);
            toast.success(res?.data?.message);
        }
        else {
            toast.error("Not able to delete income")
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setSelectedRecord("");
    };

    const handleIncomeCancel = () => {
        setIsDeleteIncomeModal(false);
        setSelectedIncomeRecord("");
    };

    const [showGroup, setShowGroup] = useState(false);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
    };

    useEffect(() => {
        refetchPropertyProvider();
    }, [isClicked,])

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                        className=""
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Clear Search
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: "#ffc069",
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            ),
    });

    const handleClick = () => {
        navigate("/property_details", {
            state: {
                propertyData: propertyDataState,
                propertyid: propertyId,
                propertyName: propertyName,
                isEdit: false
            },
        });
    };


    const formattedData = (data) => {
        const expense = data.expense ? data.expense : [];

        const newData = {
            id: expense.id,
            user_id: data.user_id,
            property_id: propertyDataState?.id,
            company_id: data.company?.id || null,
            company: data.company?.name || "",
            sub_category: data.sub_category?.name || "",
            category: data.category?.name || "",
            property: propertyDataState?.name_of_property || "",
            due_date: null,
            frequency: expense.frequency || null,
            start_date: expense.start_date,
            amount: expense.amount,
            form_fields: null,
            provider_company_id: data?.property_company_id || null,
            // Removed property_company_id to match required format
            reminder: data.is_remind ?? null,
            reminder_duration: data.remind_days ?? null,
            stream_id: null,
            payment_date: expense.start_date,
            next_payment_date: expense.next_payment_date || null,
            created_at: expense.created_at || new Date().toISOString(),
            payment_type_id: expense.payment_type_id,
            payment_type_name: expense.payment_type_id === 9 ? "One-Time" : "Recurring",
            parent_id: expense.parent_id || null,
            is_recurring_on: expense.is_recurring_on,
            country: propertyDataState?.country,
            state: propertyDataState?.state,
            city: propertyDataState?.city,
            expense_id: expense.id,
            address: propertyDataState?.address || "",
            property_type_name: propertyDataState?.property_type_name?.provider_name || "",
            from_plaid: expense.from_plaid,
        };

        return [newData];
    };

    const countTotalExpense = (data) => {
        return data?.reduce((sum, item) => sum + parseFloat(item.amount), 0);
    }

    const utilityColumns = [
        {
            title: "S.No.",
            dataIndex: "serial",
            key: "serial",
            render: (text, record, index) => {
                return index + 1;
            },
        },
        {
            title: "Company",
            dataIndex: "company_id",
            key: "company",
            render: (text, record, index) => (
                <span>
                    {record?.company?.name}</span>
            ),
            sorter: (a, b) => (a.company?.company_name).localeCompare(b.company?.name),
        },
        {
            title: "Total Expenses",
            dataIndex: "amount",
            render: (text, record, index) => (
                <span>
                    {record?.expense.amount}
                </span>
            ),
            key: "amount",
            sorter: (a, b) => (Number(a.total_expense) || 0) - (Number(b.total_expense) || 0),
        },
        {
            title: "Expense Date",
            dataIndex: "expense_date",
            key: "expense_date",
            render: (text, record, index) => (
                <span>{moment(record.start_date).format('MM-DD-YYYY')}</span>
            ),
        },
        {
            title: "Account No",
            dataIndex: "account_number",
            render: (text, record, index) => (
                <span>{record?.account_number}</span>
            ),
            key: "account_number",
            sorter: (a, b) => (a.account_number || "").localeCompare(b.account_number || ""),
        },
        {
            title: "Category",
            dataIndex: "category",
            render: (text, record, index) => (
                <span>{record?.category}</span>
            ),
            key: "category",
            sorter: (a, b) => (a.category || "").localeCompare(b.category || ""),
        },
        {
            title: "Sub Category",
            dataIndex: "sub_category",
            render: (text, record, index) => (
                <span>{record?.sub_category}</span>
            ),
            key: "sub_category",
            sorter: (a, b) => (a.sub_category || "").localeCompare(b.sub_category || ""),
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (_, record) => {
                let transformedData = formattedData(record);

                return (
                    <div className="action-container">
                        <Tooltip title="Edit">
                            <button
                                className="btn editButton me-2"
                                onClick={() => {
                                    navigate("/property_details", {
                                        state: {
                                            data: transformedData[0],
                                            propertyData: propertyDataState,
                                            isEdit: true,
                                            activePropertyID: transformedData[0]?.provider_company_id,
                                        },
                                    });
                                }}
                            >
                                <FaEdit />
                            </button>
                        </Tooltip>

                        <Tooltip title="Delete">
                            <button
                                className="btn deleteButton me-2"
                                onClick={() => {
                                    setSelectedRecord(record?.property_company_id);
                                    setIsModalOpen(true);
                                }}
                            >
                                <HiOutlineTrash />
                            </button>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];


    const redirectToIncome = () => {
        navigate(`/add_income?type=property`, { state: { propertyData: propertyDataState } });
    }

    const onChange = (key) => {
        console.log(key);
    };

    useEffect(() => {
        setTimeout(() => {
            setLoader(false);
        }, 2000);
    }, []);

    const tabItems = [
        {
            key: '1',
            label: 'Expense',
            children: (
                <>
                    <div className="card collapseCard">
                        <div className="card-header">
                            <h6 className="total-expense-property">Total Expense:  {new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: currencyGlobal && currencyGlobal?.currency_name && currencyGlobal?.currency_name.includes("Rupee") ? 'INR' : 'USD'
                            }).format(Number(totalExpense) || 0)}</h6>
                        </div>
                        <div className="card-body">
                            {isLoadingExpense ? (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <Spin />
                                </div>
                            ) : (
                                <>
                                    <Table
                                        tableLayout="fixed"
                                        className={`tableFixed table-bordered ${isRefetching ? "table-loading" : ""}`}
                                        rowKey={(record) => record?.id}
                                        bordered
                                        dataSource={expenseData || []}
                                        loading={isRefetching}
                                        scroll={{ x: '100%' }}
                                        columns={utilityColumns}
                                        showSorterTooltip={false}
                                        pagination={false}
                                    />
                                    {expenseData.length > 20 ? (
                                        <Pagination
                                            className="mt-4"
                                            total={expenseData.length}
                                            pageSize={pagesize}
                                            onChange={(page, pageSize) => {
                                                setPageSize(pageSize);
                                            }}
                                            locale={{
                                                items_per_page: `/${expenseData.length || 0} Records`,
                                            }}
                                        />
                                    ) : null}
                                </>
                            )}
                        </div>
                    </div>
                </>
            ),
        },
        {
            key: '2',
            label: 'Income',
            children: (
                <>
                    {isLoading || localLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <Spin />
                        </div>
                    ) : (
                        <div className="card collapseCard">
                            <div className="card-header">
                                <h6 className="total-expense-property">Total Income:    {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totalIncome || 0)}</h6>
                            </div>
                            <div className="card-body">
                                <Table
                                    className={`table-bordered step-two ${tableLoading ? "table-loading" : ""}`}
                                    rowKey={(record) => record.id}
                                    rowClassName={() => "editable-row"}
                                    bordered
                                    dataSource={dataSource || []}
                                    columns={Columns}
                                    scroll={{ x: "100%" }}
                                    pagination={false}
                                    loading={tableLoading}
                                    onChange={(pagination, filters, sorter) => {
                                        if (sorter.order) {
                                            const columnTitle = Columns.find(
                                                (col) => col.dataIndex === sorter.field
                                            )?.dataIndex;
                                            setColumnName(columnTitle);
                                            setTableSortBy(sorter.order === "ascend" ? "asc" : "desc");
                                        }
                                    }}
                                />

                            </div>
                        </div>
                    )}
                </>
            ),
        },
    ]

    function absString(n) {
        let numberString = n.toString();
        if (numberString[0] === '-') {
            return numberString.substring(1);
        }
        else {
            return numberString;
        }
    }

    const netProfit = statistics?.net_profit || 0;
    const numberWithoutCommas = netProfit ? netProfit?.replace(/,/g, '') : '';
    let netProfitNumber = absString(netProfit);

    return (
        <>
            {loader && (
                <div className="commanLoaderWrapper">
                    <Spin size="large" />
                    <h4>Setting things up..</h4>
                </div>
            )}
            <TopHeader
                title={<Title title="View Property" className='custom' />}
            />
            <div className="customPadding">
                <div className="breadcrumbWrapper">
                    <Breadcrumb
                        items={[
                            {
                                title: (
                                    <span onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
                                        <HomeOutlined />
                                    </span>
                                ),
                            },
                            {
                                title: (
                                    <>
                                        <span>Properties</span>
                                    </>
                                ),
                            },
                            {
                                title: (
                                    <>
                                        <span>View Property</span>
                                    </>
                                ),
                            },
                        ]}
                    />
                </div>
                <div className="mainWrapper">
                    <div className="card viewCard mb-4">
                        <div className="card-body d-block">
                            <Title
                                title={
                                    !Number.isInteger(propertyDataState?.property_id) && propertyDataState?.property_id
                                        ? propertyDataState.property_id
                                        : propertyData?.property || propertyData?.name_of_property
                                }
                                className='customClass'
                                subtitle={
                                    `${propertyData?.property_data?.address ? propertyData?.property_data?.address : propertyData?.address}, ` +
                                    `${propertyData?.city && propertyData?.city?.name ? propertyData?.city.name : propertyData?.property_data?.city ? propertyData?.property_data?.city : propertyData?.city ? propertyData?.city : propertyData?.city_id}, ` +
                                    `${propertyData?.state && !propertyData?.state?.name ? propertyData?.state : propertyData?.state?.name ? propertyData?.state?.name : propertyData?.property_data?.state ? propertyData?.property_data?.state : propertyData?.state ? propertyData?.state : propertyData?.state_id}`
                                }
                            />
                            <div className="propertyDetail mt-2">
                                <span className="colLabel">
                                    Property Type: {propertyData?.property_type_name?.provider_name ? propertyData?.property_type_name?.provider_name : propertyData?.property_type_name}
                                </span>
                            </div>

                        </div>
                    </div>

                    <div className="card tableCard">
                        <div
                            className={
                                numberWithoutCommas < 0
                                    ? "RedNumbers"
                                    : "greenNumbers"
                            }
                        >
                            <div>
                                {isStatisticsError && <div>Error loading statistics.</div>}
                                {!isStatisticsLoading && !isStatisticsError && (
                                    <>
                                        <h4>
                                            {isStatisticsLoading ? 'Loading..' : numberWithoutCommas == 0 ? 'No Profit or Loss yet' : numberWithoutCommas > 0
                                                ? `Total Profit: ${new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: currencyGlobal && currencyGlobal?.currency_name.includes("Rupee") ? 'INR' : 'USD'
                                                }).format(Number(netProfit.replace(/,/g, '').trim()) || 0)}`
                                                : `Total Loss:  ${new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: currencyGlobal && currencyGlobal?.currency_name.includes("Rupee") ? 'INR' : 'USD'
                                                }).format(Number(netProfitNumber.replace(/,/g, '').trim()) || 0)}`}
                                        </h4>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="card-header d-flex align-items-center justify-content-between border-0">
                            <Tabs
                                defaultActiveKey="1"
                                items={tabItems.map((tab) => ({
                                    ...tab,
                                    children: !showGroup ? tab.children : null,
                                }))}
                                onChange={onChange}
                            />
                        </div>

                        <div className="customBtnWrapperProeprty">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btnOutlined me-3"
                                onClick={redirectToIncome}
                            >
                                Add Income
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btnOutlined me-3"
                                onClick={handleClick}
                            >
                                Add Expense
                            </Button>
                            {showGroup && (
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="btnOutlined me-3"
                                    onClick={() => setShowGroup(false)}
                                >
                                    Hide Expense
                                </Button>
                            )}
                        </div>
                    </div>
                </div>

                <Modal
                    className="deleteModal"
                    title="Delete Expense"
                    open={isModalOpen}
                    onCancel={handleCancel}
                    footer={false}
                >
                    <div className="iconRow">
                        <RxCrossCircled />
                    </div>
                    <div className="textRow">
                        <h3>Are you sure?</h3>
                        <p>Do you really want to delete this expense?</p>
                    </div>
                    <div className="buttonRow">
                        <Button className="btnFilled text-white" style={{ marginRight: '1rem' }} onClick={() => handleOk()} loading={isLoadingDelete}>
                            Delete
                        </Button>
                        <Button className="btnOutlined me-2" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </div>
                </Modal>

                <Modal
                    className="deleteModal"
                    title="Delete Expense"
                    open={isDeleteIncomeModal}
                    onCancel={handleIncomeCancel}
                    footer={false}
                >
                    <div className="iconRow">
                        <RxCrossCircled />
                    </div>
                    <div className="textRow">
                        <h3>Are you sure?</h3>
                        <p>Do you really want to delete this income?</p>
                    </div>
                    <div className="buttonRow">
                        <Button className="btnFilled text-white" style={{ marginRight: '1rem' }} onClick={() => handleOkIncome()} loading={isLoadingDelete}>
                            Delete
                        </Button>
                        <Button className="btnOutlined me-2" onClick={handleIncomeCancel}>
                            Cancel
                        </Button>
                    </div>
                </Modal>

            </div>
        </>
    );
};

export default ViewProperty;